// extracted by mini-css-extract-plugin
export default {"errorContainer":"ErrorBoundary_errorContainer__XlV-C"};